import React from 'react';
import { Card, Container, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaStar } from 'react-icons/fa';

const RatingStars = ({ rating }) => (
    [...Array(5)].map((star, i) => (
      <FaStar key={i} color={i < rating ? "#ffc107" : "#e4e5e9"} />
    ))
  );

  const RatingComponent = ({ data, explanations }) => (
    <Container className="d-flex justify-content-center" style={{ marginBottom: '50px' }}>
      <Card style={{ maxWidth: '300px' }} className="w-100 text-center">
        <Card.Body>
          {Object.entries(data).map(([key, value]) => (
            <Row key={key} className="mb-3" style={{ justifyContent: "space-between", display: "flex" }}>
              <Col className="text-start" style={{ cursor: 'pointer' }}>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id={`tooltip-${key}`}>{explanations[key]}</Tooltip>}
                >
                  <span style={{ borderBottom: '1px dotted black' }}>{key}</span>
                </OverlayTrigger>
              </Col>
              <Col className="text-end"><RatingStars rating={value} /></Col>
            </Row>
          ))}
        </Card.Body>
      </Card>
    </Container>
  );

  export default RatingComponent;
